exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._77ePlzkoaJByVIUUnaUyb{color:\"[theme:themePrimary, default:#0078D4]\";font-size:18pt}", ""]);

// exports
exports.locals = {
	"computerImage": "_77ePlzkoaJByVIUUnaUyb"
};